// @ts-nocheck

const REVIEW_CHECK = 'Review.check';
const REVIEW_RATE = 'Review.rate';
const REVIEW_DISABLE = 'Review.disable';
const REVIEW_SHOULD_RESET = 'Review.shouldReset';
const SHARE_BASE64_IMAGE = 'Sharing.shareBase64Image';
const SHARE_TEXT = 'shareText';
const VIBRATE_DEVICE = 'App.vibrateDevice';
const AUTH_LOGIN = 'Auth.login';
const AUTH_LOGIN_AUTO = 'Auth.loginAuto';
const AUTH_LOGOUT = 'Auth.logout';
const AUTH_GET_TOKEN = 'Auth.getToken';
const AUTH_IS_AVAILABLE = 'Auth.isAvailable';
const QR_IS_AVAILABLE = 'qrIsAvailable';
const REQUEST_CAMERA_PERMISSION = 'requestCameraPermission';
const PLAY_SOUND = 'LowLatencyAudio.playSound';
const STOP_SOUND = 'LowLatencyAudio.stopSound';
const LOAD_SOUND = 'LowLatencyAudio.loadSound';
const GET_CLIENT_INFOS = 'App.getClientInfos';
const IAP_OPEN = 'InAppBrowser.openUrl';

export default {
  REVIEW_CHECK,
  REVIEW_RATE,
  REVIEW_DISABLE,
  REVIEW_SHOULD_RESET,
  SHARE_BASE64_IMAGE,
  SHARE_TEXT,
  VIBRATE_DEVICE,
  AUTH_LOGIN,
  AUTH_LOGIN_AUTO,
  AUTH_LOGOUT,
  AUTH_GET_TOKEN,
  AUTH_IS_AVAILABLE,
  QR_IS_AVAILABLE,
  REQUEST_CAMERA_PERMISSION,
  PLAY_SOUND,
  STOP_SOUND,
  LOAD_SOUND,
  GET_CLIENT_INFOS,
  IAP_OPEN,
};
